import { BaseTable, Button, Modal } from 'components'
import { CustomerPreviewType } from '../types'

type ModalPreviewType = {
  data: CustomerPreviewType[]
  show: boolean
  handleCloseModal: () => void
  handleSubmitModal: () => void
}

export const ModalPreview = ({ data, show, handleCloseModal, handleSubmitModal }: ModalPreviewType) => {
  const borderTH = "border-2 border-[#A6AEBF]"

  return (
    <div>
      {show && (
        <Modal isOpen title="DATA FORM EXCEL" closeModal={handleCloseModal}>
          <Modal.Body>
            <div className="overflow-x-auto">
              <BaseTable>
                <thead className='bg-[#EEEEEE]'>
                  <tr>
                    <th className={borderTH} rowSpan={2}>NO</th>
                    <th className={borderTH} colSpan={17}>VENDOR PROFILE</th>
                    <th className={borderTH} colSpan={7}>VENDOR ADDRESS</th>
                  </tr>
                  <tr>
                    <th className={borderTH}>FULL NAME</th>
                    <th className={borderTH}>HANDPONE</th>
                    <th className={borderTH}>EMAIL</th>
                    <th className={borderTH}>WEBSITE</th>
                    <th className={borderTH}>CARD LABEL</th>
                    <th className={borderTH}>GROUP</th>
                    <th className={borderTH}>CATEGORY</th>
                    <th className={borderTH}>SOURCE FROM</th>
                    <th className={borderTH}>MARKETING</th>
                    <th className={borderTH}>MEDIA</th>
                    <th className={borderTH}>PRICE LEVEL</th>
                    <th className={borderTH}>PAYMENT TERM</th>
                    <th className={borderTH}>MAX BALANCE</th>
                    <th className={borderTH}>BANK</th>
                    <th className={borderTH}>BANK ACCOUNT</th>
                    <th className={borderTH}>BANK BENEFICIARY</th>
                    <th className={borderTH}>BANK BRANCH</th>
                    <th className={borderTH}>ADDRESS TYPE</th>
                    <th className={borderTH}>COUNTRY</th>
                    <th className={borderTH}>PROVINCE</th>
                    <th className={borderTH}>REGENCY</th>
                    <th className={borderTH}>SUBDISTRICT</th>
                    <th className={borderTH}>VILLAGE</th>
                    <th className={borderTH}>ADDRESS</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((val, index) => (
                    <tr key={index} className="hover:bg-gray-100">
                      <td className={`${borderTH} text-center`}>{index + 1}</td>
                      <td className={`${borderTH} min-w-[300px]`}>{val.FULL_NAME ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.HANDPHONE ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.EMAIL ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.WEBSITE ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.CARD_LABEL ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.GROUP ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.CATEGORY ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.SOURCE_FROM ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.MARKETING ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.MEDIA ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.PRICE_LEVEL ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.PAYMENT_TERM ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.MAX_BALANCE ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.BANK ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.BANK_ACCOUNT ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.BANK_BENEFICIARY ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.BANK_BRANCH ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.ADDRESS_TYPE ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.COUNTRY ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.PROVINCE ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.REGENCY ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.SUBDISTRICT ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.VILLAGE ?? "-"}</td>
                      <td className={`${borderTH} min-w-[300px]`}>{val.ADDRESS ?? "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </BaseTable>
            </div>

            <Noted />
          </Modal.Body>
          <Modal.Footer className="text-end">
              <div className="flex justify-end">
              <div className="flex gap-3">
                  <Button color="error" onClick={handleCloseModal}>CANCEL</Button>
                  <Button color="primary" onClick={handleSubmitModal}>OK</Button>
              </div>
              </div>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  )
}

const Noted = () => (
  <>
    <div className="mt-5"><b>NB : </b></div>
    <div>
      <b>The data comes from the excel file you sent, it has not been corrected according to Hawk standards, after saving please review it first in the upload file list</b>
    </div>
  </>
)